import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgProceed(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M26.273 43.53L37.727 32 26.273 20.47M37.289 32H5",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M5 22C9.014 11.475 19.178 4 31.084 4 46.5 4 59 16.536 59 32S46.501 60 31.084 60C19.178 60 9.014 52.526 5 42",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0)]
  }), void 0);
}

export default SvgProceed;